<rw-modal
  modalId="apphub-confirmation-modal"
  datapendoid="apphub-confirmation-modal"
  datatestid="apphub-confirmation-modal"
  [title]="dialogTitle"
  [arialabel]="dialogTitle"
  [dismissible]="false"
  size="md"
  #modalRef
>
  <div modal-body>
    <div class="sub-title">{{ dialogMessage }}</div>
  </div>
  <div modal-footer>
    <div class="d-flex flex-wrap gap-2">
      <rw-button
        id="cancelButton"
        (clickButton)="cancel()"
        buttonclass="rw-btn-secondary"
        text="Cancel"
        arialabel="Cancel"
        datapendoid="apphub-confirmation-modal-cancel-button"
        datatestid="apphub-confirmation-modal-cancel-button"
      >
      </rw-button>
      <rw-button
        id="confirmButton"
        (clickButton)="confirm()"
        buttonclass="rw-btn-primary"
        [text]="confirmButtonText"
        [arialabel]="confirmButtonText"
        datapendoid="apphub-confirmation-modal-confirm-button"
        datatestid="apphub-confirmation-modal-confirm-button"
      >
      </rw-button>
    </div>
  </div>
</rw-modal>
